// extracted by mini-css-extract-plugin
export default {"columns":"Performance_columns__RTuw6","games":"Performance_games__Ul9js","subtitle":"Performance_subtitle__AoEdl"};